<template>
  <transition name="modal">
    <div v-if="errorPopupVisible" class="fixed" @click.self="closePopup">
      <div class="popup-card">
        <div class="popup-badge">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
        </div>
        <h2 class="title">Aviso</h2>
        <p class="message">{{ errorMessage }}</p>
        <div class="button-group">
          <button @click="closePopup" class="main_button w-full">Entendido</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, watch, defineProps } from 'vue';

const props = defineProps({
  errorMessage: String,
});

const errorPopupVisible = ref(false);

watch(() => props.errorMessage, (newVal) => {
  errorPopupVisible.value = !!newVal;
});

function closePopup(event) {
  errorPopupVisible.value = false;
  if (event) {
    event.stopPropagation();
  }
}
</script>

<style scoped>
.modal-enter-active, .modal-leave-active {
  transition: opacity 0.25s ease;
}

.modal-enter-from, .modal-leave-to {
  opacity: 0;
}

.modal-enter-active .popup-card {
  transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.25s ease;
}

.modal-enter-from .popup-card {
  transform: scale(0.94) translateY(8px);
  opacity: 0;
}

.fixed {
  z-index: 10000;
}

.popup-card {
  background-color: #FFFFFF;
  padding: 2.25rem 2rem;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-xl);
  border: 1px solid var(--border-color);
  width: 90%;
  max-width: 420px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.popup-badge {
  width: 48px;
  height: 48px;
  border-radius: var(--radius-full);
  background-color: rgba(32, 205, 168, 0.15);
  color: var(--primary-color);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

.title {
  margin-bottom: 0.5rem;
  color: var(--text-color-dark);
  font-size: 1.35rem;
  font-family: "GatterSans";
  font-weight: 700;
}

.message {
  color: var(--text-color-light);
  margin-bottom: 1.75rem;
  line-height: 1.55;
  font-size: 0.95rem;
}

.button-group {
  width: 100%;
}

.button-group button {
  height: 42px;
}

@media (max-width: 768px) {
  .popup-card {
    width: 92%;
    padding: 1.5rem;
  }
}
</style>
  